import React, {useEffect, useState, useRef} from 'react'
import AutoLocation from 'sr/helpers/ui-components/AutoLocation'
export const ReportWorkLocation = (props) => {
  const [address, setAddress] = useState({});
  const [currentaddress, setCurrentAddress] = useState<any>();
  const initialRegionRef = useRef<string | null>(null);

  const getRegionId = (rawLoc: any) => {
    if (!rawLoc) return "";
    if (typeof rawLoc === "string") return rawLoc;
    if (typeof rawLoc.regionId === "string") return rawLoc.regionId;
    if (typeof rawLoc.regionId?._id === "string") return rawLoc.regionId._id;
    if (typeof rawLoc.regionId?.id === "string") return rawLoc.regionId.id;
    if (typeof rawLoc.region_id === "string") return rawLoc.region_id;
    if (typeof rawLoc.region?.id === "string") return rawLoc.region.id;
    if (typeof rawLoc.region?._id === "string") return rawLoc.region._id;
    if (typeof rawLoc.region === "string") return rawLoc.region;
    return "";
  };

  useEffect(()=> {
    const updatedAddress = props?.data?.job_advanced_id?.reporting_address
    setCurrentAddress(updatedAddress)
    initialRegionRef.current = getRegionId(updatedAddress);
  },[props?.data])

  const HandleAutoLocation = (data)=> {
       setAddress(data)
  }
  useEffect(()=> {
    const data: any = {
      reporting_address: address,
    }
    
    // Check if the region actually changed
    const newRegionId = getRegionId(address);
    if (initialRegionRef.current !== null && newRegionId && newRegionId !== initialRegionRef.current) {
        data.reporting_regions = [];
    }
    
    props?.HandleDataProps(data)
    
  },[address])


  return ( 
    <div className="pt-10">
      <AutoLocation HandleAutoLocation={HandleAutoLocation} address={currentaddress} />
    </div>
  )
}
